import { CollapsiblePanel } from "./collapsiblePanel";
import { ToggleSwitch } from "../base/toggle/toggleSwitch";

interface IMapSettingsProps {
  isEnable3DMap?: boolean;
  isEnableQRCode?: boolean;
  isShowLables?: boolean;
  isShowQRCode?: boolean;
  onShowLablesToggle: () => void;
  onEnable3DMapToggle: () => void;
  onQRCodeToggle?: () => void;
}

export const MapSettings = (props: IMapSettingsProps) => {
  return (
    <CollapsiblePanel header="Map Settings">
      <div>
        <div className="flex gap-4 mb-4">
          <ToggleSwitch
            onToggle={props.onEnable3DMapToggle}
            isOn={props.isEnable3DMap}
            label="Enable 3D Map"
          />
        </div>
        <div className="flex  gap-4 mb-4">
          <ToggleSwitch
            onToggle={props.onShowLablesToggle}
            isOn={props.isShowLables}
            label="Show Labels"
            disabled={props.isEnable3DMap}
          />
        </div>
        {props.isShowQRCode && (
          <div className="flex  gap-4">
            <ToggleSwitch
              onToggle={props.onQRCodeToggle ? props.onQRCodeToggle : () => {}}
              isOn={props.isEnableQRCode}
              label="Create Check-in Point"
              disabled={!props.isEnable3DMap}
            />
          </div>
        )}
      </div>
    </CollapsiblePanel>
  );
};
